import { Form, FormInstance, Checkbox, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { CategoryStepUIConfig } from '../../../shared/CategoryStepUIConfig';
import { MultipleChoiceQuestionUIConfig } from '../../../shared/MultipleChoiceQuestionUIConfig';
import { MultipleChoiceQuestion } from '../NewApplicationWizard/MultipleChoiceQuestion';
import { CategoryAnswerType } from '../NewApplicationWizard/CategoryAnswerType';

interface CategoryStepProps {
	uiConfig: CategoryStepUIConfig;
	form: FormInstance;
	updateFieldValue: (questionId: number, value: number) => void;
}

export const CategoryStep = ({
	uiConfig: { questions },
	form,
	updateFieldValue,
}: CategoryStepProps) => {
	const { t } = useTranslation();
	const formValues = Form.useWatch<CategoryAnswerType>([], form);

	const allQuestions = questions.map(
		(question: MultipleChoiceQuestionUIConfig) => (
			<Card
				key={question.questionId}
				className="my-5 !border !rounded-lg !border-gray-250 !bg-gray-100 p-0"
			>
				<div key={question.questionId} className="my-[8px]">
					<MultipleChoiceQuestion
						uiConfig={question}
						value={{
							selectedOption: formValues?.[question.questionId].selectedOption,
						}}
						updateFieldValue={updateFieldValue}
					/>
				</div>
			</Card>
		)
	);

	return (
		<div className="flex flex-col h-full min-h-0 max-w-[600px]">
			<Form
				name="basic"
				layout="vertical"
				size="middle"
				labelCol={{ span: 16 }}
				style={{ maxWidth: 600 }}
				initialValues={{ remember: true }}
				autoComplete="off"
				form={form}
			>
				{allQuestions}
				<Form.Item
					name="foundationOfServingIsIntegrity"
					valuePropName="checked"
				>
					<Checkbox className="font-bold text-black-100 [&_.ant-checkbox-inner]:border-black-100 [&_.ant-checkbox-inner]:border-2">
						{t('foundationOfServingIsIntegrity')}
					</Checkbox>
				</Form.Item>
			</Form>
		</div>
	);
};
